import { DataSource, TreeSelectOption } from '@qfa/forms';

import {
  toSignalIntegrationLocationOption,
  useIntersectionsLocationTreeDataSource,
} from './useIntersectionsLocationTreeDataSource';

export const useDatabaseEditorTreeDataSource = (): DataSource<TreeSelectOption[]> => {
  const dataSource = useIntersectionsLocationTreeDataSource({
    centerIds: 'all',
    groupsDisabled: true,
    toLocationOption: toSignalIntegrationLocationOption,
  });
  return dataSource;
};
